import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}

export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
    canDeactivate(component: ComponentCanDeactivate ): boolean | Observable<boolean>| Promise<boolean> {
        return component.canDeactivate()
            ? true
            : confirm( 'You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.' );
    }
}

